import { render } from "./CardApps.vue?vue&type=template&id=5444f840&scoped=true"
import script from "./CardApps.vue?vue&type=script&lang=js"
export * from "./CardApps.vue?vue&type=script&lang=js"

import "./CardApps.vue?vue&type=style&index=0&id=5444f840&lang=scss&scoped=true"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5444f840"]])

export default __exports__